import {useMemo} from 'react';

const useFirmSearchSelect = firms =>
  useMemo(
    () =>
      firms.map(({id, name}) => ({
        id,
        search: name.toLowerCase(),
        text: name,
      })),
    [firms]
  );

export default useFirmSearchSelect;
